// extracted by mini-css-extract-plugin
export var link = "incompatibleBrower-module--link--1LY4q";